import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AuthActions, selectIsRefreshTokenLoading } from "@redux";
import { Logout, i18, trb, secondsToMinutesWithSeconds } from "@utilities";
import { SESSIONS_STORAGE_ITEMS } from "@config";

const TIMER_IN_SECONDS = 60 * 5;

export const UserActive = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const isOkBtnLoading = useSelector(selectIsRefreshTokenLoading);

  const [timer, setTimer] = useState(TIMER_IN_SECONDS);

  useEffect(() => {
    const logoutTimer = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }

      if (timer === 0) {
        Logout();
      }
    }, 1000);
    return () => {
      clearInterval(logoutTimer);
    };
  }, [timer]);

  const onContinue = async () => {
    const parsedItem = JSON.parse(sessionStorage.getItem(SESSIONS_STORAGE_ITEMS.USER));
    const refreshToken = parsedItem ? parsedItem.refreshToken : null;
    if (refreshToken) {
      const response = await dispatch(AuthActions.refreshToken(refreshToken));
      if (response && response.payload) {
        sessionStorage.setItem(SESSIONS_STORAGE_ITEMS.USER, JSON.stringify(response.payload));
      }
    }
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Modal
      visible={open}
      maskClosable={false}
      closable={false}
      title={trb(i18.ModalTitles.TitleRefresh)}
      okText={trb(i18.Buttons.Ok)}
      onCancel={Logout}
      cancelText={trb(i18.Buttons.Logout)}
      onOk={onContinue}
      okButtonProps={{ loading: isOkBtnLoading }}
      cancelButtonProps={{ disabled: isOkBtnLoading }}
    >
      {`${trb(i18.ModalTitles.RefreshModal)} ${secondsToMinutesWithSeconds(timer)}`}
    </Modal>
  );
};
